/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Bump_EditInputs */

const cs_portals_bump_edit = /** @type {(inputs: Portals_Bump_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bump plán`)
};

const en_portals_bump_edit = /** @type {(inputs: Portals_Bump_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bump schedule`)
};

/**
* | output |
* | --- |
* | "Bump schedule" |
*
* @param {Portals_Bump_EditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_edit = /** @type {((inputs?: Portals_Bump_EditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_EditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_edit(inputs)
	return cs_portals_bump_edit(inputs)
});